<template>
    <div>
        <data-table url="ivr/provider"
                    model="Provider" :fields="fields"
                    action-buttons primary-key="slug" no-modal
                    create
        ></data-table>
    </div>
</template>

<script>
    export default {
        name: "List",
        data() {
            return {
                fields: [
                    { field: 'name', label: 'Nombre', sort: true, hasFilter: false, filter: '', filterAdd: null  },
                    { field: 'phone', label: 'Teléfono', sort: true, hasFilter: false, filter: '', filterAdd: null  },
                    { field: 'extension', label: 'Extensión', sort: true, hasFilter: false, filter: '', filterAdd: null  },
                ]
            }
        }
    }
</script>

<style scoped>

</style>
